import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#5e3a9d",
      },
      dark: {
        primary: "#5e3a9d",
      },
    },
  },
});
